'use client'

import { getLocalizedUri, LangCode } from "@/components/i18n/lang-context"
import { SITE_IS_JBDA } from "@/config/site.config"
import { notFound, usePathname } from "next/navigation"

export function IsAuthorizedPath({children, langCode}: {children: React.ReactNode, langCode: LangCode}) {
  if (SITE_IS_JBDA) {
    const pathName = usePathname()
    console.log()
    if (
      pathName !== getLocalizedUri('/', langCode) &&
      pathName !== getLocalizedUri('/legal/cgu', langCode) &&
      pathName !== getLocalizedUri('/legal/legal-mentions', langCode) &&
      pathName !== getLocalizedUri('/legal/privacy-policy', langCode) &&
      pathName !== getLocalizedUri('/not-found', langCode)
    )
    return notFound()
  }
  return <>{children}</>
}